import { render, staticRenderFns } from "./ResponseCheckbox.vue?vue&type=template&id=08560dfa&"
import script from "./ResponseCheckbox.vue?vue&type=script&lang=js&"
export * from "./ResponseCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports